import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../v2/LoginPageV2';
import { ApplicationEntrySaveAndExitButton } from './ApplicationEntrySaveAndExitButton';
import { ApplicationEntryNavigationButtons } from './ApplicationEntryNavigationButtons';
import { ProgressBreadcrumbList, ProgressBreadcrumbListTheme, ProgressBreadcrumb, Button } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

type ProgressBreadcrumbProps = ComponentProps<typeof ProgressBreadcrumb>;
type ButtonProps = ComponentProps<typeof Button>;
export interface MobileApplicationEntryPanelProps {
    children: any;
    sections: ProgressBreadcrumbProps[];
    currentSection: number;
    printMode?: boolean;
    saveAndExitButtonProps: ButtonProps;
    nextStepButtonProps: ButtonProps;
    previousStepButtonVisible?: boolean;
    propertyAddress?: string;
}

export const MobileApplicationEntryPanel: React.FC<MobileApplicationEntryPanelProps> = ({
    children,
    sections,
    currentSection,
    printMode,
    saveAndExitButtonProps,
    nextStepButtonProps,
    previousStepButtonVisible,
    propertyAddress,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntry-mobile'>
                <div className='applicationEntry-mobile-appWrapper'>
                    <div className='applicationEntry-mobile-header'>
                        <div className='applicationEntry-mobile-header-image'>
                            <img
                                src='/assets/img/logo.webp.html'
                                alt='Builder Finance'
                                height='38px'
                            />
                        </div>
                        <div className='applicationEntry-mobile-header-topButton'>
                            <ApplicationEntrySaveAndExitButton saveAndExitButtonProps={saveAndExitButtonProps} />
                        </div>
                    </div>
                    <div className='applicationEntry-mobile-contextIndicator'>
                        <div className='applicationEntry-mobile-contextIndicator-process'>Apply</div>
                        <div className='applicationEntry-mobile-contextIndicator-addressLocator'>
                            {propertyAddress && (
                                <>
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        style={{ paddingRight: '5px' }}
                                    />{' '}
                                    {propertyAddress}
                                </>
                            )}
                        </div>
                    </div>
                    <div className='applicationEntry-mobile-progressIndicator'>
                        <ProgressBreadcrumbList
                            id='applicationEntrySidebarVerticalBreadcrumb'
                            theme={ProgressBreadcrumbListTheme.Blue}
                            activeCrumbNumber={currentSection}
                            crumbs={sections}
                            orientation='horizontal'
                        />
                    </div>
                    <div className='applicationEntry-mobile-appWrapper-contentWrapper'>
                        <div className='applicationEntry-mobile-appWrapper-content'>{children}</div>
                    </div>
                    <div className='applicationEntry-mobile-appWrapper-navigationButtons'>
                        <ApplicationEntryNavigationButtons
                            nextStepButtonProps={nextStepButtonProps}
                            previousStepButtonVisible={previousStepButtonVisible}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
